import Joi from 'joi';
import {getJoiObject} from '../../../utils/JoiUtils';
import {yesterdayDate,} from 'web-library';

export interface CreateNewAnnouncementData {
  announcementTitle: string;
  startDate: string;
  endDate: string;
}

export type CreateNewAnnouncementDisableInputs = {
  [P in keyof CreateNewAnnouncementData]?: boolean;
};

const createNewAnnouncementSchema = (isDisableInputs?: CreateNewAnnouncementDisableInputs) =>
    Joi.object({
      announcementTitle: getJoiObject(
          Joi.string().trim().min(1).required().messages({
            'any.required': 'Title is not allowed to be empty.',
            'string.empty': 'Title is not allowed to be empty.',
          }),
          isDisableInputs?.announcementTitle
      ),
      startDate: getJoiObject(
          Joi.date().min(yesterdayDate).required().messages({
            'date.base': 'Start Date is not allowed to be empty.',
            'date.min': 'Start Date should not be earlier than current date.',
          }),
          isDisableInputs?.startDate
      ),
      endDate: getJoiObject(
          Joi.date().required().min(yesterdayDate).min(Joi.ref('startDate')).messages({
            'date.base': 'End Date is not allowed to be empty.',
            'date.min': 'End Date should be equal or same as Start Date.',
          }),
          isDisableInputs?.endDate
      ),
    });

export default createNewAnnouncementSchema;
